/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  ListProducts.tsx
*
* Project Title :  Checkout
*
* Description	: Purchase Software page
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H175591
*
* @Date		    : Oct 1, 2019
*
* @Version      : Version 1.0
*
* By            : Madhu Gali - H175591
* On            : Oct 10, 2019
* Description   : ASDS-1476
*
* By            : H224423
* On            : Oct 10, 2019
* Description   : ASDS-1478 - Grid level resposnive changes and UI issue fixes. Reordered the elements.
*
* By            : E860178
* On            : Oct 24, 2019
* Description   : Category Name added to Save cart details - ASDS-1598
*
* By            : E844276
* On            : Feb 17, 2020
* Description   : ASDS-954 - Verbiage Changes
******************************************************************************/
import React from 'react';
import { Grid, Card } from '@scuf/common';
import StockProductOptions from './StockProductOptions';
import VirtualProductOptions from './VirtualProductOptions';
import ProductListingHeader from './ProductListingHeader';
import { CategoryListing } from '..';
import CheckoutConstants from 'modules/checkout/constants/checkout-constants';

interface ProductListingComponentPropsI {
    categories: CategoryListing[];
    selectedCategory: string;
    onClickConfigureButton: any;
    onClickAPUConfigureButton: any;
    configureModelOpen: boolean;
    configureAPUModelOpen: boolean;
    configureWirelessModelOpen: boolean;
    showAlertMsg: boolean;
    hideAlert: Function;
    addToCartButtonClicked: Function;
}

/**
* @author ASDS Team
* @description Lists all products for a criteria, if any.
* @param props
 */
function ListProducts(props: ProductListingComponentPropsI) {
    return (
        <Grid.Row>
                <Grid.Column className="productList fullwidthRow">
                    <Grid>
            <ProductListingHeader />
            {
                props.categories.map(category => (
                    category.products && category.products.map((product,index) => (
                        !product.hidden &&
                        <Grid.Column width={12} key={index} className="productList">
                            <Card className="purchaseSoftwareCard">
                                <Card.Content>
                                    <Grid className="productListFullWidth">
                                      <Grid.Row>
                                        <Grid.Column width={1} xsWidth={2} xsOrder={1} className="productIcon">
                                            {product.productName.toLowerCase().includes(CheckoutConstants.APU_PRODUCT_NAME)
                                            &&<i className={CheckoutConstants.APU_PRODUCT_CLASSNAME}></i>}

                                            {product.productName.toLowerCase().includes(CheckoutConstants.ASPIRE_PRODUCT_NAME)
                                            &&<i className={CheckoutConstants.ASPIRE_PRODUCT_CLASSNAME}></i>}

                                            {product.productName.toLowerCase().includes(CheckoutConstants.DLMUW_PRODUCT_NAME)
                                            &&<i className={CheckoutConstants.DLMUW_PRODUCT_CLASSNAME}></i>}

                                            {product.productName.toLowerCase().includes(CheckoutConstants.ANALYZER_SERVICE_CENTERS_PRODUCT_NAME)
                                            &&<i className={CheckoutConstants.ANALYZER_PRODUCT_CLASSNAME}></i>}

                                            {product.productName.toLowerCase().includes(CheckoutConstants.FAULT_ANALYZER_SERVICES_PRODUCT_NAME)
                                            &&<i className={CheckoutConstants.FAULT_PRODUCT_CLASSNAME}></i>}

                                            {product.productName.toLowerCase().includes(CheckoutConstants.REMOTE_TERMINAL_SERVICES_PRODUCT_NAME)
                                            &&<i className={CheckoutConstants.REMOTE_TERMINAL_PRODUCT_CLASSNAME}></i>}
                                        </Grid.Column>
                                        <Grid.Column width={7} xsWidth={10} xsOrder={2} className="productName">
                                            <div className="product-name-text">{product.productName}</div>
                                        </Grid.Column>
                                        <Grid.Column width={2} xsWidth={5} xsOrder={3} className="productName">
                                        {product.buttonLabel && product.buttonLabel.toLowerCase() === 'configure' ?
                                            <div className="price-label-text">Configure for Price</div>:<div className="price-label-text">{"$"}{product.price}</div>}
                                        </Grid.Column>
                                        <Grid.Column width={2} xsWidth={7} xsOrder={4} className="productName">
                                            {product.buttonLabel && product.buttonLabel.toLowerCase() === 'configure' ?
                                                <VirtualProductOptions
                                                    onClickConfigureButton={props.onClickConfigureButton}
                                                    onClickAPUConfiguration={props.onClickAPUConfigureButton}
                                                    product={product}
                                                    system={category.system}
                                                    categoryName={category.categoryName}
                                                /> :
                                                <StockProductOptions
                                                    product={product}
                                                    system={category.system}
                                                    categoryName={category.categoryName}
                                                    addToCartButtonClicked={props.addToCartButtonClicked}
                                                />}
                                        </Grid.Column>
                                      </Grid.Row>
                                      <Grid.Row>
                                        <Grid.Column width={1} xsWidth={1} xsOrder={7} className="productIcon"/>
                                        <Grid.Column width={7} xsWidth={7} xsOrder={5}>
                                            <Grid.Column className="applicable padd-bottom-10" width={12}>
                                                <div className="platform-label-text">{product.platformLabel}</div>
                                            </Grid.Column>
                                            <Grid.Column className="productName padd-bottom-10" width={12}>
                                                <div className="platform-text">{product.platforms}
                                                {product.config && <a href={product.config.template} className="co-link-text">&nbsp; &nbsp; Download</a>}
                                                </div>
                                            </Grid.Column>
                                        </Grid.Column>
                                      </Grid.Row>
                                    </Grid>
                                </Card.Content>
                                {
                                    product.note && <Card.Footer>
                                        <p>{product.note}</p>
                                    </Card.Footer>
                                }
                            </Card>
                        </Grid.Column>
                    ))
                ))
            }
            </Grid>
       </Grid.Column>
       </Grid.Row>
    );
}

export default ListProducts;